import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface EmailLogsRequest {
  searchTerm?: string;
  per_page?: number;
  page?: number;
}

export interface EmailLogsResponse {
  Status: boolean;
  msgCode: string;
  message: string;
  data: {
    current_page: number;
    data: EmailLog[];
    first_page_url: string;
    from: number;
    last_page: number;
    last_page_url: string;
    links: PaginationLink[];
    next_page_url: string | null;
    path: string;
    per_page: number;
    prev_page_url: string | null;
    to: number;
    total: number;
  };
  Token: string;
}

export interface PaginationLink {
  url: string | null;
  label: string;
  active: boolean;
}

export interface EmailLog {
  id: number;
  UserId: number;
  TemplateIdentifier: string;
  MessageId: string;
  Email: string;
  DynamicData: string;
  Status: string;
  Type: string;
  Day: number;
  CreatedDate: string;
  UpdatedDate: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class EmailLogsService {
  private apiUrl = `${environment.BASE_API}api/orders/getReminderEmailLogs`;

  constructor(private http: HttpClient) {}

  getReminderEmailLogs(params: EmailLogsRequest = {}): Observable<EmailLogsResponse> {
    let httpParams = new HttpParams();

    if (params.searchTerm) {
      httpParams = httpParams.set('CustomerId', params.searchTerm);
    }

    if (params.per_page) {
      httpParams = httpParams.set('per_page', params.per_page.toString());
    } else {
      httpParams = httpParams.set('per_page', '50'); // Default value
    }

    if (params.page) {
      httpParams = httpParams.set('page', params.page.toString());
    }

    return this.http.get<EmailLogsResponse>(this.apiUrl, { params: httpParams });
  }
} 